import { useState } from 'react'
import AdminWebsiteCard from './AdminWebsiteCard';

export default function AdminWebsites({admin, websites, theme}) {
  const [websiteSearchTerm, setWebsiteSearchTerm] = useState("");
  const deployWebsites = ()=>{
    const filtered = websiteSearchTerm==="" ? 
    websites : 
    websites.filter((website)=>{
      return website?.settings?.website_name.includes(websiteSearchTerm.trim()) || website?.owner?.name.includes(websiteSearchTerm.trim()) || website?.settings?.domain.includes(websiteSearchTerm.trim())
    })
    return filtered.length > 0 ? filtered.map((website, inx)=>{
      return <AdminWebsiteCard key={`adminClientCard_inx_${inx}`} admin={admin} website={website} theme={theme}/>
    }) : <h1 style={{color:theme?.accent_color, textShadow:`1px 1px 3px ${theme?.primary_color}`}}>לא נמצאו לקוחות</h1>;
  }
  return (
    <div className='adminWebsites'>
      <h2 style={{margin:"0",color:theme.accent_color, textShadow:`2px 2px 4px ${theme.primary_color}`, fontSize:"50px"}}>רשימת האתרים</h2>
      <input className='adminWebsites_input' type='text' placeholder='חפש לקוח...'  onChange={(e)=>{setWebsiteSearchTerm(e.target.value)}}/>
      <div className='adminWebsites_list'>
        {deployWebsites()}
      </div>
    </div>
  )
}
